<script setup lang="ts">
import { PROJECT_TYPES_VALUES, type ProjectType } from '@@/shared/property/types';
import IadChipGroup from '~/components/iad/IadChipGroup.vue';

const modelValue = defineModel<Array<ProjectType>>({ default: [] });
</script>

<template>
  <div>
    <IadChipGroup v-model="modelValue">
      <IadChip
        v-for="projectType of PROJECT_TYPES_VALUES"
        :key="projectType"
        :label="$t(`property_serp.filters.project_type.${projectType}`)"
        :value="projectType"
      />
    </IadChipGroup>
  </div>
</template>
